import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    width: "fit-content",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: "16px",
    gap: "8px",
    backgroundColor: theme.palette.grey.grey100
  },
  icon: {
    width: "20px",
    marginBottom: "5px"
  },
  message: {
    color: theme.palette.grey.grey700,
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
  }
}));

export default useStyles;
